import { render, staticRenderFns } from "./IndustryFactor.vue?vue&type=template&id=11583794&"
import script from "./IndustryFactor.vue?vue&type=script&lang=js&"
export * from "./IndustryFactor.vue?vue&type=script&lang=js&"
import style0 from "./IndustryFactor.vue?vue&type=style&index=0&id=11583794&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports